import { MAIN_SCREEN, SCREEN } from '../../constant'
import {
  getDefaultFinance,
  getPanelListFinance,
  getPanelPortfolioByFinance,
} from './finance'
import { getDefaultScore, getPanelListScore, getPanelScore } from './score'
import {
  getDefaultSegment,
  getPanelListSegment,
  getPanelPortfolioBySegment,
} from './segment'
import {
  getDefaultSummary,
  getPanelListSummary,
  getPanelSummary,
} from './summary'

export const getPanelPortfolioInsight = ({ screen, panel, setting = {} }) => {
  switch (screen) {
    case SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SUMMARY:
      return getPanelSummary(panel, setting)
    case SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE:
      return getPanelPortfolioByFinance(panel, setting)
    case SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE:
      return getPanelScore(panel, setting)
    case SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SEGMENT:
      return getPanelPortfolioBySegment(panel, setting)
    default:
      return {}
  }
}

export const getPanelListPortfolioInsight = () => {
  return [
    ...getPanelListSummary(),
    ...getPanelListFinance(),
    ...getPanelListScore(),
    ...getPanelListSegment(),
  ]
}

export const getDefaultPortfolioInsight = () => {
  return [
    ...getDefaultSummary(),
    ...getDefaultFinance(),
    ...getDefaultScore(),
    ...getDefaultSegment(),
  ]
}
